// extracted by mini-css-extract-plugin
export default {"emailLink":"About_emailLink__38lj4"};